import { api } from "./api";

export interface UtilityData {
  UtilityTypeId: number;
  UtilityTypeName: string;
  Usage: number;
  Amount: number;
  Paid: number;
  Outstanding: number;
}

export interface UtilityResponse {
  utilityDatas: UtilityData[] | null;
  TotalAmount: number;
  TotalPaid: number;
  TotalOutstanding: number;
  DueDate: string;
  LastUpdate: string;
  Code: number;
  Message: string;
}

export const GetUtilityData = async (isreload: boolean = false): Promise<UtilityResponse | null> => {
  try {
    const tenantid =
      localStorage.getItem("tenant_id") ||
      sessionStorage.getItem("tenant_id");

    if (!tenantid) {
      console.log("tenant_id not found in storage");
      return null;
    }

    const url = `/dashboard/v2/utility?tenantid=${tenantid}&isreload=${isreload ? 1 : 0}`;
    const response = await api.get<UtilityResponse>(url);

    if (response.status === 200 && response.data) {
      return response.data;
    }

    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};